import { WithStyles, withStyles } from '@mui/styles';

import { muiStyles } from './apiConnectionsStyles';
import { ApiConnections } from './apiConnectionsView';

export interface IApiConnectionsProps extends WithStyles<typeof muiStyles> {
    setCurrentPage: () => void;
}

export default withStyles(muiStyles)(ApiConnections);